import { ApolloLink } from '@apollo/client'
import convertLiveDirectives from '@/lib/graphql/convert-live-directives'

/**
 * Removes the unparsed @live directives from queries
 */
export default class LiveLink extends ApolloLink {
  request(operation: Record<string, any>, forward: any) {
    const newQuery = convertLiveDirectives(operation.query)
    if (newQuery !== operation.query) {
      operation.query = newQuery
      console.error(
        `You are using @live directive in operation "${operation.operationName}" with an incompatible hook from @apollo/client. Import your query hook from @/lib/hooks instead.`,
        operation
      )
    }
    return forward(operation)
  }
}
